<template>
    <div>
        <section class="section has-background-primary">
            <br><br>
            <div class="container has-text-centered">
                <br>
                <h2 class="title has-text-white">Book a call</h2>
                <p class="subtitle is-6 has-text-white">Fill in the form below and we will call you back to discuss any questions you may have</p>
                <br><br>
            </div>
        </section>

        <div class="container has-text-centered">
            <div class="box shift-up">
                <form class="has-text-left">
                    <Field
                        autocomplete="given-name"
                        placeholderText="First name"
                        id="fname"
                        name="fname"
                        v-model="form.fname"
                        :inputDirty="$v.form.fname.$dirty"
                        :inputRequired="$v.form.fname.required"
                        @input="$v.form.fname.$touch()"
                        :reset="allReset"
                        type="text"
                    >
                    </Field>
                    <Field
                        autocomplete="family-name"
                        placeholderText="Surname"
                        id="lname"
                        name="lname"
                        v-model="form.sname"
                        :inputDirty="$v.form.sname.$dirty"
                        :inputRequired="$v.form.sname.required"
                        @input="$v.form.sname.$touch()"
                        :reset="allReset"
                        type="text"
                    >
                    </Field>
                    <Field
                        autocomplete="mobile tel-national"
                        placeholderText="Cell number"
                        id="mobile"
                        name="mobile"
                        v-model="form.cell_num"
                        :inputDirty="$v.form.cell_num.$dirty"
                        :inputExtra="$v.form.cell_num.checkCell"
                        :inputRequired="$v.form.cell_num.required"
                        @input="$v.form.cell_num.$touch()"
                        :reset="allReset"
                        type="tel"
                        v-mask="'0## ### ####'"
                    >
                        <p class="help is-danger" v-if="$v.form.cell_num.$dirty & $v.form.cell_num.required & !$v.form.cell_num.checkCell">Please enter a valid cell number (e.g. 084 123 4567)</p>
                    </Field>
                    <Field
                        autocomplete="home email"
                        placeholderText="Email address"
                        id="email"
                        name="email"
                        v-model="form.email_addr"
                        :inputDirty="$v.form.email_addr.$dirty"
                        :inputExtra="$v.form.email_addr.email"
                        :inputRequired="$v.form.email_addr.required"
                        :reset="allReset"
                        @input="$v.form.email_addr.$touch()"
                        type="email"
                    >
                        <p class="help is-danger" v-if="$v.form.email_addr.$dirty & $v.form.email_addr.required & !$v.form.email_addr.email">Please enter a valid email address</p>
                    </Field>
                    <Field
                        autocomplete="new-password"
                        placeholderText="Confirm email address"
                        id="email_addr_confirm"
                        v-model="form.email_addr_confirm"
                        :inputDirty="$v.form.email_addr_confirm.$dirty"
                        :inputExtra="$v.form.email_addr_confirm.email"
                        :inputRequired="$v.form.email_addr_confirm.required"
                        :reset="allReset"
                        @input="$v.form.email_addr_confirm.$touch()"
                        type="email"
                    >
                        <p class="help is-danger" v-if="$v.form.email_addr_confirm.$dirty & $v.form.email_addr_confirm.required & !$v.form.email_addr_confirm.sameAsEmail">Please make sure both email addresses match</p>
                    </Field>
                    <Field
                        autocomplete="new-password"
                        placeholderText="Message"
                        id="contact_msg"
                        v-model="form.contact_msg"
                        :inputDirty="$v.form.contact_msg.$dirty"
                        :inputRequired="$v.form.contact_msg.required"
                        :reset="allReset"
                        @input="$v.form.contact_msg.$touch()"
                        type="textarea"
                    >
                    </Field>
                    <br>
                    <div class="field">
                        <div class="control">
                            <div v-if="allReset">
                                <p >Thanks! We will get back to you as soon as possible</p>
                                <br>
                            </div>
                            <button class="button is-primary is-rounded" :disabled="$v.form.$invalid || allReset" type="button" @click="submitForm">{{ sendButtonTxt }}</button>
                        </div>
                    </div>
                </form>

                </div>
            </div>

        <section class="section">
            <div class="container">
                <h1 class="title has-text-centered">Contact us</h1>
                <br>
                <div class="columns">
                    <div class="column blue-column">
                        <h3>Physical Address</h3>
                        <br>
                        <ul>
                            <li>Ground Floor, 4 Oakdale Rd</li>
                            <li>Newlands</li>
                            <li>Cape Town</li>
                            <li>7700</li>
                        </ul>
                    </div>

                    <div class="column blue-column">
                        <h3>Contact NestEgg Head Office</h3>
                        <br>
                        <ul>
                            <li><a href="mailto:listings@mynestegg.co.za">service@mynestegg.co.za</a></li>
                            <li><a href="tel:+27212017298">+27 21 201 7296</a></li>
                        </ul>
                    </div>

                    <div class="column blue-column">
                        <h3>Contact the NestEgg Listings Team</h3>
                        <br>
                        <ul>
                            <li><a href="mailto:listings@mynestegg.co.za">listings@mynestegg.co.za</a></li>
                            <li><a href="tel:+27212017298">+27 21 201 7298</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <br><br>
    </div>
</template>

<script>
    import axios from 'axios'
    import Field from '../components/Field.vue'
    import { required, email, sameAs } from 'vuelidate/lib/validators/'

    const stripCellMask = (value) => value.replace(/\D/g, "").replace(/^(27)?0?/g, "");
    const checkCell = (value) => {
        var clean_cell = stripCellMask(value);
        return clean_cell.length === 9 && parseInt(clean_cell.substring(0, 2), 10) >= 60;
    };

    export default {
        components: {
          Field
        },
        data: function() {
            return {
                form: {
                    fname: '',
                    sname: '',
                    email_addr: '',
                    email_addr_confirm: '',
                    cell_num: '',
                    contact_msg: ''
                },
                allReset: false,
                sendButtonTxt: 'Send'
            }
        },
        methods: {
            submitForm() {
                var orig_this = this,
                    oldSendButtonTxt = this.sendButtonTxt;
                this.sendButtonTxt = 'Sending ...';

                axios.post(process.env.VUE_APP_POST_URL + '/api/submit.php', 
                    JSON.stringify(
                        {
                            'LeadId': this.$parent.leadid,
                            'FirstName': this.form.fname,
                            'Surname': this.form.sname,
                            'CellNumber': this.form.cell_num,
                            'EmailAddress': this.form.email_addr,
                            'ContactMessage': this.form.contact_msg,
                            'SubmissionType': 'ContactUs',
                            'Token': document.getElementById('csrf').value
                        }
                    )
                )
                .finally(function() {
                    orig_this.allReset = true;
                    orig_this.sendButtonTxt = oldSendButtonTxt;
                    orig_this.$nextTick(() => { orig_this.$v.$reset() });
                });
            }
        },
        validations: {
            form: {
                fname: {
                    required
                },
                sname: {
                    required
                },
                email_addr: {
                    required,
                    email
                },
                email_addr_confirm: {
                    required,
                    sameAsEmail: sameAs('email_addr')
                },
                cell_num: {
                    required,
                    checkCell
                },
                contact_msg: {
                    required
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/colours.scss';
    .blue-column {
        background-color: $light-blue;
        border-radius: 10px;
        margin: 0 1em;

        a {
            color: $black;
        }
    }

    .box {
        border: 2px solid $grey-lighter;
    }

    .pops-out {
        max-height: 0;
        transition: max-height .2s ease;
        margin-bottom: 0 !important;
        padding-left: calc(calc(0.75em - 1px) + 0.375em);
    }

    .popped-out {
        max-height: 1.5rem;
    }
</style>